<template>
    <div v-if="lang === 'ru'" class="flex w-full flex-column gap-2">
        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            1. Общие положения
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок обработки и защиты персональных данных пользователей (далее — «Пользователь», «Вы») проекта PayWave (далее — «Проект», «Сервис», «Мы»), доступного по адресу: <a href="https://pay-wave.co/" target="_blank" class="text-primary">https://pay-wave.co/</a>, а также через связанные Telegram-интерфейсы, мобильные или иные цифровые платформы.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Используя Сервис, вы подтверждаете, что ознакомлены с настоящей Политикой и соглашаетесь с её условиями.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            2. Оператор персональных данных
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            На момент публикации настоящей Политики обработка персональных данных осуществляется проектом PayWave, управляемым командой без образования юридического лица.
        </p>
        <span class="w-full">
            <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
                Контактные данные:
            </p>
            <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base gap-2 pl-3">
                <li>
                    <span>Email:</span> <a href="mailto:info@pay-wave.co" class="text-primary">info@pay-wave.co</a>
                </li>
                <li>
                    <span>Telegram:</span> <a href="https://t.me/pw_origin_bot" class="text-primary" target="_blank">https://t.me/pw_origin_bot</a>
                </li>
                <li>
                    <span>Веб-сайт:</span> <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>
                </li>
            </ul>
        </span>
        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            3. Персональные данные, подлежащие обработке
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Мы обрабатываем следующие категории персональных данных:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Фамилия, имя, отчество;</li>
            <li>Адрес электронной почты, номер телефона, страна проживания;</li>
            <li>Реквизиты платёжных средств и транзакций;</li>
            <li>Идентификационные документы (паспорт, удостоверение личности, селфи и иные сведения, необходимые для целей KYC/AML);</li>
            <li>IP-адрес, данные о браузере, устройстве и файлах cookies;</li>
            <li>Иные сведения, предоставляемые Пользователем добровольно.</li>
        </ul>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            4. Цели обработки персональных данных
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Персональные данные обрабатываются исключительно в следующих целях:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Оказание услуг Сервиса, включая обмен валют, переводы средств, доступ к цифровым кошелькам и иным финансовым продуктам;</li>
            <li>Идентификация Пользователя, в том числе для выполнения требований KYC/AML;</li>
            <li>Связь с Пользователем, информирование об изменениях условий обслуживания;</li>
            <li>Обеспечение безопасности, предотвращение мошеннических действий;</li>
            <li>Улучшение качества Сервиса, проведение аналитики и технической поддержки;</li>
            <li>Соблюдение требований действующего законодательства.</li>
        </ul>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            5. Правовые основания обработки
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Обработка персональных данных осуществляется на основании одного или нескольких из следующих оснований:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Согласие субъекта персональных данных;</li>
            <li>Необходимость исполнения договора между Пользователем и Сервисом;</li>
            <li>Соблюдение правовых обязательств, возложенных на Проект;</li>
            <li>Законные интересы Проекта, не нарушающие права и свободы Пользователя.</li>
        </ul>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            6. Условия обработки и хранения
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Персональные данные обрабатываются с соблюдением принципов законности, справедливости и минимизации. Данные хранятся на защищённых серверах в течение периода, необходимого для достижения целей обработки, но не менее срока, установленного нормативными актами.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            7. Передача данных третьим лицам
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Мы можем передавать персональные данные в следующих случаях:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Провайдерам, обеспечивающим функции идентификации (KYC/AML), платёжной обработки, хостинга, IT-поддержки;</li>
            <li>Уполномоченным государственным органам по их требованию в порядке, установленном законом;</li>
            <li>Другим третьим лицам — при наличии вашего отдельного согласия.</li>
        </ul>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Мы не передаём персональные данные третьим лицам без правовых оснований.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            8. Права пользователя
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Пользователи имеют право:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Запрашивать информацию о своих персональных данных, хранимых Сервисом;</li>
            <li>Требовать исправления или удаления своих данных;</li>
            <li>Ограничивать обработку в соответствии с законодательством;</li>
            <li>Отозвать ранее данное согласие на обработку;</li>
            <li>Обратиться в уполномоченные органы по защите персональных данных в случае нарушения их прав.</li>
        </ul>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Для реализации этих прав Пользователь может обратиться по контактам, указанным в разделе 2.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            9. Использование cookies и технических данных
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Сайт и интерфейсы проекта PayWave могут использовать cookies и аналогичные технологии для:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Аутентификации и сохранения пользовательских сессий;</li>
            <li>Сбора статистики и аналитики;</li>
            <li>Обеспечения корректной работы интерфейса.</li>
        </ul>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Пользователь может ограничить или отключить cookies в настройках своего браузера.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            10. Передача данных за пределы юрисдикции
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            В связи с международным характером Сервиса, персональные данные могут передаваться на территории других государств, включая страны с отличными от вашей юрисдикции уровнями защиты данных. Мы принимаем меры по обеспечению надлежащего уровня защиты при такой передаче.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            11. Обновление Политики
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Мы оставляем за собой право вносить изменения в настоящую Политику в любое время. Актуальная версия всегда доступна по адресу: <a href="https://pay-wave.co/privacy" class="text-primary" target="_blank">https://pay-wave.co/policy/</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Использование Сервиса после вступления изменений в силу означает согласие Пользователя с новой редакцией Политики.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            12. Контактная информация
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            По вопросам, связанным с обработкой персональных данных:
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Email: <a href="mailto:info@pay-wave.co" class="text-primary">info@pay-wave.co</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Telegram: <a href="https://t.me/pw_origin_bot" class="text-primary" target="_blank">https://t.me/pw_origin_bot</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Сайт: <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>
        </p>
    </div>
    <div v-else class="flex w-full flex-column gap-2">
        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            1. General Provisions
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            This Privacy Policy (hereinafter referred to as the "Policy") defines the procedure for processing and protecting personal data of users (hereinafter referred to as the "User", "You") of the PayWave project (hereinafter referred to as the "Project", "Service", "We"), available at <a href="https://pay-wave.co/" target="_blank" class="text-primary">https://pay-wave.co/</a>, as well as through related Telegram interfaces, mobile or other digital platforms.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            By using the Service, you confirm that you have read this Policy and agree to its terms.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            2. Personal Data Operator
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            At the time of publication of this Policy, the processing of personal data is carried out by the PayWave project, managed by a team without forming a legal entity.
        </p>
        <span class="w-full">
            <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
                Contact details:
            </p>
            <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base gap-2 pl-3">
                <li>
                    <span>Email:</span> <a href="mailto:info@pay-wave.co" class="text-primary">info@pay-wave.co</a>
                </li>
                <li>
                    <span>Telegram:</span> <a href="https://t.me/pw_origin_bot" class="text-primary" target="_blank">https://t.me/pw_origin_bot</a>
                </li>
                <li>
                    <span>Website:</span> <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>
                </li>
            </ul>
        </span>
        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            3. Personal Data Subject to Processing
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            We process the following categories of personal data:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Last name, first name, patronymic;</li>
            <li>Email address, phone number, country of residence;</li>
            <li>Payment and transaction details;</li>
            <li>Identification documents (passport, ID card, selfie, and other information required for KYC/AML purposes);</li>
            <li>IP address, browser, device data, and cookies;</li>
            <li>Other information voluntarily provided by the User.</li>
        </ul>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            4. Purposes of Personal Data Processing
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Personal data is processed exclusively for the following purposes:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Provision of Service, including currency exchange, money transfers, access to digital wallets and other financial products;</li>
            <li>User identification, including for KYC/AML requirements;</li>
            <li>Communication with the User, informing about changes in service terms;</li>
            <li>Ensuring security, preventing fraudulent activities;</li>
            <li>Improving Service quality, analytics, and technical support;</li>
            <li>Compliance with applicable laws.</li>
        </ul>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            5. Legal Grounds for Processing
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Personal data is processed on the basis of one or more of the following grounds:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>User's consent;</li>
            <li>Necessity to perform a contract between the User and the Service;</li>
            <li>Compliance with legal obligations imposed on the Project;</li>
            <li>Legitimate interests of the Project that do not violate the rights and freedoms of the User.</li>
        </ul>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            6. Conditions of Processing and Storage
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Personal data is processed in accordance with the principles of lawfulness, fairness, and minimization. Data is stored on secure servers for the period necessary to achieve the purposes of processing, but not less than the period established by regulatory acts.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            7. Transfer of Data to Third Parties
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            We may transfer personal data in the following cases:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>To providers performing identification (KYC/AML), payment processing, hosting, IT support functions;</li>
            <li>To authorized government bodies upon their request as required by law;</li>
            <li>To other third parties — with your separate consent.</li>
        </ul>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            We do not transfer personal data to third parties without legal grounds.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            8. User Rights
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Users have the right to:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Request information about their personal data stored by the Service;</li>
            <li>Request correction or deletion of their data;</li>
            <li>Restrict processing in accordance with the law;</li>
            <li>Withdraw previously given consent to processing;</li>
            <li>Contact authorized data protection authorities in case of violation of their rights.</li>
        </ul>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            To exercise these rights, the User may contact us using the contacts specified in section 2.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            9. Use of Cookies and Technical Data
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            The PayWave website and interfaces may use cookies and similar technologies for:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Authentication and saving user sessions;</li>
            <li>Collecting statistics and analytics;</li>
            <li>Ensuring correct interface operation.</li>
        </ul>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            The User may restrict or disable cookies in their browser settings.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            10. Transfer of Data Outside Jurisdiction
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Due to the international nature of the Service, personal data may be transferred to other countries, including those with different levels of data protection than your jurisdiction. We take measures to ensure an adequate level of protection during such transfers.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            11. Policy Updates
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            We reserve the right to make changes to this Policy at any time. The current version is always available at: <a href="https://pay-wave.co/privacy" class="text-primary" target="_blank">https://pay-wave.co/policy/</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Use of the Service after changes take effect means the User agrees to the new version of the Policy.
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            12. Contact Information
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            For questions related to the processing of personal data:
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Email: <a href="mailto:info@pay-wave.co" class="text-primary">info@pay-wave.co</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Telegram: <a href="https://t.me/pw_origin_bot" class="text-primary" target="_blank">https://t.me/pw_origin_bot</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Website: <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'Policy',
        computed: {
            lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        },
    }
</script>
